export enum WorkOrderRoles {
  WorkOrderViewer = 'WorkOrderViewer',
  WorkOrderEditor = 'WorkOrderEditor',
  WorkOrderAdmin = 'WorkOrderAdmin',
}

export enum PurchaseOrderRoles {
  PurchaseOrderViewer = 'PurchaseOrderViewer',
  PurchaseOrderEditor = 'PurchaseOrderEditor',
  PurchaseOrderAdmin = 'PurchaseOrderAdmin',
}

/** Sees and creates Administrative (confidential) purchase orders (#5942). The API enforces it; the UI only hides. */
export enum AdministrativePurchaseOrderRoles {
  AdministrativePurchaseOrderAdmin = 'AdministrativePurchaseOrderAdmin',
}

export enum IMEXViewerGroup {
  InvoiceViewer = 'InvoiceViewer',
  ShipmentViewer = 'ShipmentViewer',
}

export enum IMEXEditorGroup {
  ShipmentEditor = 'ShipmentEditor',
}

export enum IMEXAdminGroup {
  InvoiceAdmin = 'InvoiceAdmin',
  ShipmentAdmin = 'ShipmentAdmin',
  ShipmentSupervisor = 'ShipmentSupervisor',
}

export enum ExternalRequisitionViewerGroup {
  ExternalRequisitionViewer = 'ExternalRequisitionViewer',
}
export enum ExternalRequisitionAdminGroup {
  ExternalRequisitionAdmin = 'ExternalRequisitionAdmin',
}

export enum DeliveryNoteRoles {
  DeliveryNoteViewer = 'DeliveryNoteViewer',
  DeliveryNoteAdmin = 'DeliveryNoteAdmin',
}
export enum PlantManagerGroup {
  PlantManager = 'PlantManager',
}

export enum ClientPurchaseOrderRoles {
  ClientPurchaseOrderViewer = 'ClientPurchaseOrderViewer',
  ClientPurchaseOrderEditor = 'ClientPurchaseOrderEditor',
  ClientPurchaseOrderAdmin = 'ClientPurchaseOrderAdmin',
}

export enum OrderReportingRoles {
  OrderReportingViewer = 'OrderReportingViewer',
  OrderReportingAdmin = 'OrderReportingAdmin',
}
